import { gql } from '@apollo/client';

export const ZOOM_ACCOUNT_FIELDS = gql`
  fragment ZoomAccountFields on ZoomAccountType {
    id
    zoomUserId
    email
    displayName
    isActive
    notes
    syncedAt
    createdAt
  }
`;

export const ZOOM_RECORDING_FIELDS = gql`
  ${ZOOM_ACCOUNT_FIELDS}
  fragment ZoomRecordingFields on ZoomRecordingType {
    id
    pk
    zoomMeetingUuid
    zoomMeetingId
    topic
    startTime
    durationMinutes
    totalSizeBytes
    files
    deletedFromZoom
    deletedAt
    syncedAt
    isOrphan
    isMatched
    isTooShort
    status
    failureReason
    zoomAccount {
      ...ZoomAccountFields
    }
  }
`;

/** Zoom account storage/usage summary — backs the dashboard storage widget. */
export const ZOOM_ACCOUNT_USAGE_FIELDS = gql`
  fragment ZoomAccountUsageFields on ZoomAccountUsageType {
    id
    usersCount
    recordingsCount
    filesCount
    recordingsSizeBytes
    planStorageTotalBytes
    planStorageUsedBytes
    planStorageFreeBytes
    storageUsedPercent
    planRecordingType
    planUsageAvailable
    syncedAt
  }
`;

export const GROUP_LESSON_FOR_ZOOM_FIELDS = gql`
  fragment GroupLessonForZoomFields on GroupLessonForLMSType {
    id
    name
    number
    date
    startTime
    endTime
    video
    lmsDescription
    finished
    module {
      id
      group {
        id
        name
        zoomAccount {
          id
          displayName
        }
        course {
          id
          name
        }
      }
    }
  }
`;

export const LESSON_RECORDING_FIELDS = gql`
  ${ZOOM_RECORDING_FIELDS}
  ${GROUP_LESSON_FOR_ZOOM_FIELDS}
  fragment LessonRecordingFields on LessonRecordingType {
    id
    status
    matchedBy
    ambiguous
    transcriptS3Key
    chatS3Key
    audioS3Key
    aiSummary
    aiTimecodes
    aiModel
    errorMessage
    retryCount
    lastAttemptAt
    # ТЗ 0043: считает СЕРВЕР. Правило «застряла» завязано на порог давности
    # lastAttemptAt, и вторая его копия на фронте разъехалась бы с проверкой
    # в мутации — кнопка активна, а мутация отбивает.
    # (Бэктики внутри gql-литерала обрывают шаблонную строку — их здесь нет.)
    canResume
    createdAt
    updatedAt
    matchedByUser {
      id
      email
      firstName
      lastName
    }
    lesson {
      ...GroupLessonForZoomFields
    }
    zoomRecording {
      ...ZoomRecordingFields
    }
  }
`;

/** A GroupLesson with its (optional) LessonRecording — the row shape for the
 *  lesson-centric `allZoomLessons` query. */
export const ZOOM_LESSON_FIELDS = gql`
  ${LESSON_RECORDING_FIELDS}
  fragment ZoomLessonFields on GroupLessonForLMSType {
    ...GroupLessonForZoomFields
    zoomRecordingMeta {
      ...LessonRecordingFields
    }
  }
`;

/** One step of a lesson's automatic Zoom processing journal. */
export const ZOOM_PROCESSING_LOG_FIELDS = gql`
  fragment ZoomProcessingLogFields on ZoomProcessingLogType {
    id
    step
    level
    message
    details
    createdAt
    lessonRecording {
      id
      status
    }
  }
`;

/** One «week day + time» slot of a group's Zoom auto-processing schedule. */
export const GROUP_ZOOM_SCHEDULE_FIELDS = gql`
  fragment GroupZoomScheduleFields on GroupZoomScheduleType {
    id
    weekDay
    runTime
    isActive
    group {
      id
      name
    }
  }
`;

export const ZOOM_AUDIT_ENTRY_FIELDS = gql`
  fragment ZoomAuditEntryFields on ZoomAuditLogType {
    id
    action
    targetKind
    targetId
    details
    createdAt
    user {
      id
      email
      firstName
      lastName
    }
  }
`;
